var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 982,
    transform: "translate(-834 -534)",
    fill: "#131311"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 0.25C35.3471 0.25 26.8885 2.81589 19.6938 7.6232C12.4992 12.4305 6.89162 19.2633 3.58029 27.2576C0.268956 35.2519 -0.59744 44.0485 1.09066 52.5352C2.77877 61.0219 6.94555 68.8174 13.0641 74.9359C19.1826 81.0545 26.9782 85.2213 35.4648 86.9094C43.9515 88.5975 52.7482 87.7311 60.7424 84.4197C68.7367 81.1084 75.5695 75.5008 80.3768 68.3062C85.1841 61.1115 87.75 52.6529 87.75 44C87.75 32.3968 83.1407 21.2688 74.9359 13.0641C66.7312 4.85936 55.6032 0.25 44 0.25ZM67.2719 46.7969L29.7719 65.5469C29.2953 65.785 28.7658 65.8974 28.2336 65.8733C27.7014 65.8492 27.1842 65.6894 26.7312 65.4092C26.2781 65.1289 25.9042 64.7375 25.645 64.2721C25.3857 63.8067 25.2498 63.2827 25.25 62.75V25.25C25.2503 24.7175 25.3866 24.194 25.6461 23.729C25.9056 23.264 26.2795 22.873 26.7325 22.5931C27.1855 22.3133 27.7025 22.1538 28.2344 22.1298C28.7663 22.1059 29.2956 22.2182 29.7719 22.4562L67.2719 41.2062C67.7903 41.4661 68.2261 41.865 68.5308 42.3584C68.8354 42.8517 68.9967 43.4202 68.9967 44C68.9967 44.5798 68.8354 45.1483 68.5308 45.6416C68.2261 46.135 67.7903 46.5339 67.2719 46.7937",
    fill: "#FEC200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBlack);
export default __webpack_public_path__ + "static/media/playBlack.b9ce0e7033e09f7fc58d1f9ff87cf0e8.svg";
export { ForwardRef as ReactComponent };